import React from 'react';
import { Link } from 'react-router-dom';

const SupportPage: React.FC = () => (
  <div style={styles.page}>
    <h1 style={styles.title}>Support</h1>
    <p style={styles.sub}>We're here to help. Reach us anytime.</p>

    <div style={styles.card}>
      <div style={styles.item}>
        <span style={styles.icon}>✉️</span>
        <div>
          <p style={styles.label}>Email</p>
          <a href="mailto:support@moashops.com" style={styles.value}>support@moashops.com</a>
        </div>
      </div>
      <div style={styles.divider} />
      <div style={styles.item}>
        <span style={styles.icon}>🕐</span>
        <div>
          <p style={styles.label}>Hours</p>
          <p style={styles.value}>Mon – Fri, 9:00 AM – 6:00 PM (EST)</p>
        </div>
      </div>
    </div>

    <div style={styles.links}>
      <Link to="/partnership" style={styles.link}>Partnership Inquiry</Link>
      <Link to="/privacy" style={styles.link}>Privacy Policy</Link>
      <Link to="/terms" style={styles.link}>Terms of Service</Link>
    </div>
  </div>
);

const styles: Record<string, React.CSSProperties> = {
  page: { maxWidth: 600, margin: '60px auto', padding: '0 20px 120px' },
  title: { fontSize: 26, fontWeight: 700, color: '#333', marginBottom: 8 },
  sub: { fontSize: 14, color: '#999', marginBottom: 40 },
  card: { background: '#fff', border: '1px solid #f0f0f0', borderRadius: 16, padding: '8px 0', marginBottom: 32 },
  item: { display: 'flex', alignItems: 'center', gap: 16, padding: '20px 24px' },
  icon: { fontSize: 24, flexShrink: 0 },
  label: { fontSize: 11, color: '#aaa', fontWeight: 600, letterSpacing: 0.5, textTransform: 'uppercase', marginBottom: 4 },
  value: { fontSize: 14, color: '#333', textDecoration: 'none' },
  divider: { height: 1, background: '#f5f5f5', margin: '0 24px' },
  links: { display: 'flex', gap: 24, flexWrap: 'wrap' as const },
  link: { fontSize: 13, color: '#bbb', textDecoration: 'none' },
};

export default SupportPage;
